export default {"src":"/_next/static/media/icon_checked_white.00ae5394.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};